<template>
  <div class="news">

    <div class="news">
      <div class="black-background">
        <div class="container">
        <div class="news-inside row">
          <div class="col col-12 col-lg-4 col-md-6"
          v-for="(item, index) in content" :key="index">
            <card :newscard="item"/>
          </div>
        </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import card from '@/components/news_card.vue';

export default {
  props: {
    newscard: {
      type: Array,
      default: () => ([{
        topic: '這是標題',
        categories: '這是種類',
        content: '這是內容',
        image: 'https://picsum.photos/800/800?random=1',
      },
      {
        topic: '這是標題',
        categories: '這是種類',
        content: '這是內容',
        image: 'https://picsum.photos/800/800?random=1',
      },
      ]),
    },
  },
  data() {
    return {
      content: this.newscard,
    };
  },
  components: {
    card,
  },
};
</script>
<style lang="scss" scoped>
.news{
  // background-image: url('https://picsum.photos/800/800?random=8');
  // background-repeat: no-repeat;
  // background-size: cover;
  // background-attachment: fixed;
  .black-background{
    padding: 50px 0;
    // background: rgba(0, 0, 0, 0.5);
    .news-inside{
      margin: auto;
      color: #222;
      .col {
        margin: 0;
        margin-bottom: 10px;
        padding: 0;
      }
    }
  }
}
</style>
